export default __webpack_public_path__ + "static/media/UploadCredentials.902713e8.png";